<template>
  <f7-page name="asset-alarm-position">
    <!-- Top Navbar -->
    <f7-progressbar v-if="isLoading" infinite color="green" class="progressbar-top"></f7-progressbar>
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Back">
      </f7-nav-left>
      <f7-nav-title sliding>{{ pageTitle }}</f7-nav-title>
      <f7-nav-right>
        <!--<f7-link :href="`/assets/last-alarms/?id=${f7route.query.id}&name=${f7route.query.name}`" icon="f7-icons icon-notification"></f7-link>
        <f7-link @click="getAssetLocation" href="#" icon-f7="arrow_2_circlepath"></f7-link>-->
      </f7-nav-right>
    </f7-navbar>

    <div class="map-wrapper">
      <l-map
          ref="map"
          :zoom="zoom"
          :center="center"
          style="height: 100%"
          :options="{zoomControl: false, tap: false, preferCanvas: true}"
      >
        <l-control-layers position="topright"  ></l-control-layers>
        <l-tile-layer
            v-for="tileProvider in tileProviders"
            :key="tileProvider.name"
            :name="tileProvider.name"
            :visible="tileProvider.visible"
            :url="tileProvider.url"
            :subdomains="tileProvider.subdomains"
            layer-type="base"/>

        <l-marker
            v-if="markerLatLng.length"
            :lat-lng="markerLatLng"
            :icon="markerIcon"
        >
          <!--<l-icon :icon-url="iconUrl" :icon-size="[40,40]" :icon-anchor="[20, 39]" />-->

          <l-popup>
            <table cellpadding="0" cellspacing="0" border="0" class="marker-data-table">
              <tbody>
              <tr>
                <td class="marker-data-caption">{{ $t('Name') }}</td>
                <td class="marker-data-value">{{ f7route.query.name }}</td>
              </tr>
              <tr>
                <td class="marker-data-caption">{{ $t('AlarmName') }}</td>
                <td class="marker-data-value">{{ alertData.CustomAlarmName }}</td>
              </tr>
              <tr>
                <td class="marker-data-caption">{{ $t('PositionTime') }}</td>
                <td class="marker-data-value">{{ alertData.CustomAlarmTime }}</td>
              </tr>
              <!--<tr>
                <td class="marker-data-caption">{{ $t('Mileage') }}</td>
                <td class="marker-data-value">{{ mapPopupData.mileage }} {{ mileageUnit }}</td>
              </tr>-->
              <tr>
                <td class="marker-data-caption">{{ $t('Speed') }}</td>
                <td class="marker-data-value">{{ alertData.Speed }} {{ speedUnit }}</td>
              </tr>
              <!--<tr>
                <td class="marker-data-caption">{{ $t('Direction') }}</td>
                <td class="marker-data-value">{{ directionFormat(mapPopupData.Direct) }}</td>
              </tr>-->
              <tr>
                <td class="marker-data-caption">{{ $t('GPS') }}</td>
                <td class="marker-data-value marker-address asset-address">{{ parseFloat(alertData.Lat).toFixed(4) }}, {{ parseFloat(alertData.Lng).toFixed(4) }}</td>
              </tr>
              <tr>
                <td class="marker-data-caption">{{ $t('Address') }}</td>
                <td class="marker-data-value marker-address asset-address">{{ customAddress ? customAddress : $t('Loading') }}</td>
              </tr>
              </tbody>
            </table>
          </l-popup>
        </l-marker>

      </l-map>
    </div>
  </f7-page>

</template>

<script>
import L from 'leaflet';
import { LMap, LTileLayer, LMarker, LControlLayers, LPopup } from "@vue-leaflet/vue-leaflet";
import {mapGetters} from "vuex";
import { f7 } from 'framework7-vue';
import { dateFormat, directionText } from "../../js/helpers";
import { QTAPI } from "../../services/qt-api"

export default {
  name: "asset-alarm-position",
  components: {
    LMap, LTileLayer, LMarker, LControlLayers, LPopup
  },

  props: {
    f7router: Object,
    f7route: Object,

    alertData: { type: Object, default: () => { return {} } },
  },

  computed: {
    ...mapGetters(['MinorToken'])
  },

  data: function(){
    let mapCenter = L.latLng(47.41322, -1.219482)
    let markerLatLng = []
    if(this.alertData.Lat && this.alertData.Lng){
      mapCenter = L.latLng(this.alertData.Lat, this.alertData.Lng)
      markerLatLng = [this.alertData.Lat, this.alertData.Lng]
    }
    return {
      pageTitle: this.alertData.CustomAlarmName,
      isLoading: false,
      isIncorrectData: false,

      zoom: 9,
      center: mapCenter,
      map: '',

      tileProviders: [
        {
          name: 'Map',
          visible: true,
          url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
          //subdomains: ['mt0','mt1','mt2','mt3']
          subdomains: ['mt0','mt1','mt2','mt3']
        },
        {
          name: 'OpenStreetMap',
          visible: false,
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        },
        {
          name: 'Satelitte',
          visible: false,
          url: 'https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',
          subdomains: ['mt0','mt1','mt2','mt3']
        },
      ],

      markerIcon: L.icon({
        iconUrl: './static/images/map-marker.svg',
        iconSize:     [40, 40], // size of the icon
        iconAnchor:   [20, 39], // point of the icon which will correspond to marker's location
        popupAnchor:  [0, -40] // point from which the popup should open relative to the iconAnchor
      }),
      markerLatLng: markerLatLng,
      //mapPopupData: this.f7route.alertData,
      mileageUnit: 'km',
      speedUnit: 'km/h',
      //assetName: f7.views.main.router.currentRoute.query.name,
      customAddress: ''
    }
  },

  async mounted() {
    if (this.alertData.Lat && this.alertData.Lng){
      this.getAddress({Lat: this.alertData.Lat, Lng: this.alertData.Lng})
    }
  },

  methods: {
    directionFormat(direction){
      return directionText(direction) + `(${direction}°)`
    },
    dateFormat(...options){
      return dateFormat(...options)
    },

    async getAddress(coords){
      const response = await QTAPI.GetAddressByCoords({
        latitude: coords.Lat,
        longitude: coords.Lng
      })
      if (!response) {
        return
      }
      this.customAddress = response.display_name
    },
  }
}
</script>

<style scoped lang="scss">

</style>